import { UnderNavigation } from '../UnderNavigation/UnderNavigation';
import './AppsBanner.scss';

function AppsBanner(props){
    return(
        <div className="apps-shared-banner" style={{ backgroundImage: `url(${props.backgroundImage})` }}>
            <h1>{props.title}</h1>
            {props.desc ? <p>{props.desc}</p> : null}
            <div className="other">
                {props.btn1 ? props.btn1 : null}
                {props.btn2 ? props.btn2 : null}
               
            </div>
            <UnderNavigation />
        </div>
    )
};
export default AppsBanner ;